// Liste sayfası başlık çubuğu — başlık + sayaç + arama + yenile + sağ aksiyonlar.
//
// <ListPageHeader
//   title="Banka Hesapları"
//   count={accounts.length}
//   unit="hesap"                 // "5 hesap" → opsiyonel; verilmezse sadece sayı gösterilir
//   search={search}
//   onSearch={v => { setSearch(v); setPage(1); }}
//   searchPlaceholder="Hesap adi, banka, IBAN ara..."
//   onRefresh={fetchAccounts}    // verilirse "↻ Yenile" butonu gösterilir
//   refreshing={loading}         // refresh sırasında butonu disable etmek için
//   actions={<><Button>Bankalar</Button><Button>+ Yeni</Button></>}
// />
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';

export default function ListPageHeader({
  title,
  count = null,
  unit = '',
  search = '',
  onSearch = null,
  searchPlaceholder = null,         // null ise i18n default kullanılır
  onRefresh = null,
  refreshing = false,
  actions = null,
  extra = null,
}) {
  const { t } = useTranslation();
  return (
    <div className="stocks-topbar">
      <div className="stocks-topbar-left">
        <h2>{title}</h2>
        {count != null && (
          <span className="stocks-count-badge">{count}{unit ? ' ' + unit : ''}</span>
        )}
        {extra}
      </div>
      <div className="stocks-topbar-right">
        {onSearch && (
          <div className="stocks-search">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input placeholder={searchPlaceholder || t('ui.searchPlaceholder')} value={search} onChange={e => onSearch(e.target.value)} />
          </div>
        )}
        {onRefresh && (
          <Button variant="ghost" size="sm" onClick={onRefresh} disabled={refreshing} title={t('common.refresh')}>
            ↻ {t('common.refresh')}
          </Button>
        )}
        {actions}
      </div>
    </div>
  );
}
